import { FC } from 'react';

interface EmptyIllustrationProps {
  className?: string;
}

const EmptyIllustration: FC<EmptyIllustrationProps> = ({ className }) => {
  return (
    <svg
      width="480"
      height="431"
      viewBox="0 0 480 431"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity=".195"
        d="M208.812 58.297c-15.748-6.412-32.389-11.78-49.377-11.098-24.996.985-48.936 16.034-60.697 38.133-9.964 18.72-11.193 40.666-15.485 61.441-5.287 25.599-15.412 49.926-26.232 73.718-5.813 12.762-11.943 25.833-12.896 39.843-1.326 19.446 7.956 38.828 22.508 51.777 14.553 12.948 33.893 19.76 53.283 21.25 10.325.793 21.111.059 30.283-4.754 9.702-5.092 16.773-14.298 26.512-19.314 9.029-4.668 19.586-5.305 29.72-4.698a132.839 132.839 0 0 1 38.802 8.259c14.163 5.33 27.334 13.046 41.467 18.448 14.134 5.403 29.923 8.421 44.37 3.909 13.557-4.244 24.292-14.514 33.964-24.933a436.335 436.335 0 0 0 43.298-54.876c8.723-13.088 16.84-26.898 20.699-42.155 7.372-29.165-2.775-62.073-25.288-81.995-18.64-16.501-43.674-23.664-68.174-28.01-22.339-3.964-48.169-4.21-68.734-14.54-19.615-9.868-37.459-22.027-58.023-30.404z"
        fill="currentColor"
      />
      <ellipse
        opacity=".2"
        cx="19.269"
        cy="88.167"
        rx="9.164"
        ry="9.18"
        fill="currentColor"
      />
      <ellipse
        opacity=".2"
        cx="459.907"
        cy="161.525"
        rx="9.164"
        ry="9.18"
        fill="currentColor"
      />
      <ellipse
        opacity=".2"
        cx="295.182"
        cy="59.015"
        rx="9.164"
        ry="9.18"
        fill="currentColor"
      />
      <ellipse
        opacity=".2"
        cx="37.596"
        cy="138.811"
        rx="15.357"
        ry="15.385"
        fill="currentColor"
      />
      <ellipse
        opacity=".2"
        cx="412.669"
        cy="64.504"
        rx="15.357"
        ry="15.385"
        fill="currentColor"
      />
      <path
        d="M353.24 113.699c.063-.144.114-.297.165-.45a9.482 9.482 0 0 0-.424 1.04c.089-.2.178-.395.259-.59z"
        fill="url(#z8lir6rusa)"
      />
      <path
        d="M317.013 273.295c-.153 1.889-4.792 1.176-4.792 1.176-7.693 1.069-6.422-6.485-6.422-6.485v-.386l.267-7.045.076-1.965s8.473-3.879 8.257-3.065c-.08.306.097 1.04.343 1.834.424 1.32 1.03 2.814 1.03 2.814s.05 3.115-.204 4.031c-.254.917 1.326 3.37 1.326 3.37s0 .153.026.425a49.77 49.77 0 0 1 .093 5.296zM331.845 275.337s-4.639.717-4.791-1.176a48.222 48.222 0 0 1 .08-5.309c0-.255.021-.425.021-.425s1.58-2.453 1.326-3.369c-.254-.917-.203-4.037-.203-4.037s.165-.394.381-.963c.453-1.193 1.136-3.128.996-3.68-.204-.819 8.257 3.06 8.257 3.06l.084 2.199.259 6.811v.387s1.288 7.575-6.41 6.502z"
        fill="#B77983"
      />
      <path
        opacity=".05"
        d="m323.181 120.116 6.626-1.329a.422.422 0 0 0-.118.276l-.085.136-1.462 1.532-4.961 2.517-4.041-1.294-.513-4.864 2.144-3.82c-2.03 4.244-.051 7.258-.051 7.258l2.461-.412zM361.929 142.04c-.018.045-.034.09-.047.136a1.839 1.839 0 0 1-.246.425l-2.673 1.307-4.08.424-2.118-5.139 1.411-5.632.779-1.053.216-.237c.081 1.018.492 6.332.467 7.928-.034 1.769 1.27 1.909 1.27 1.909l5.021-.068zM314.776 257.359c-3.186 3.794-6.626 3.73-8.676 3.196l.076-1.965s8.473-3.879 8.257-3.065c-.081.306.08 1.04.343 1.834zM337.997 261.654c-5.411 3.132-8.584-.539-9.321-1.579.453-1.192 1.136-3.128.996-3.679-.204-.82 8.257 3.06 8.257 3.06l.068 2.198zM332.201 230.405s5.147-2.971 6.27-1.634c1.123 1.337-6.27 1.634-6.27 1.634zM335.311 232.039s-.848.424 1.021.968c1.868.543-1.021-.968-1.021-.968zM304.185 223.869c-.174.051 4.283 3.014 8.307.561-.016 0-7.303-.866-8.307-.561zM312.272 229.535s-1.22 2.402-3.719 2.759c-2.5.356 3.719-2.759 3.719-2.759zM328.634 234.747s5.863 9.337 4.74 11.539c-1.122 2.203-4.74-11.539-4.74-11.539zM317.064 271.873c0 .522 0 1.011-.051 1.414-.153 1.888-4.792 1.175-4.792 1.175-4.236.59-5.761-1.447-6.265-3.395a7.794 7.794 0 0 1-.234-1.935 8.076 8.076 0 0 1 .077-1.163v-.386a2.828 2.828 0 0 1 2.635.539c1.885 1.532 4.385.356 4.385.356s1.834.153 2.542.764c.398.344 1.055-.484 1.554-1.273.03.509.077 1.43.106 2.415.034.505.043 1.014.043 1.489z"
        fill="#000"
      />
      <path
        opacity=".05"
        d="M309.624 271.763s-1.271 1.248-3.668-.679a7.747 7.747 0 0 1-.233-1.935c1.224.933 3.495 2.614 3.901 2.614zM317.064 271.874a.958.958 0 0 1-1.377-.221 9.18 9.18 0 0 0 1.356-1.273c.012.509.021 1.018.021 1.494zM327.007 272.748c0 .526 0 1.014.046 1.413.153 1.893 4.792 1.176 4.792 1.176 4.237.594 5.762-1.443 6.266-3.396a8.164 8.164 0 0 0 .157-3.098v-.386a2.866 2.866 0 0 0-2.64.539c-1.885 1.532-4.38.356-4.38.356s-1.835.158-2.542.769c-.399.343-1.055-.484-1.551-1.274-.03.51-.08 1.431-.11 2.415a19.619 19.619 0 0 0-.038 1.486z"
        fill="#000"
      />
      <path
        opacity=".05"
        d="M334.446 272.629s1.271 1.248 3.665-.679a7.76 7.76 0 0 0 .237-1.931c-1.228.929-3.499 2.61-3.902 2.61zM327.007 272.748a.952.952 0 0 0 1.373-.221 8.98 8.98 0 0 1-1.356-1.273 44.515 44.515 0 0 0-.017 1.494zM321.415 142.431s-6.525 18.041-4.012 19.607c2.512 1.566 4.012-19.607 4.012-19.607zM326.172 136.863s-1.228 5.992-.614 6.536c.614.543.614-6.536.614-6.536zM339.348 150.821s-8.02 7.487-7.478 8.102c.543.616 7.478-8.102 7.478-8.102zM345.478 134.342c-3.037.929-10.138 3.102-10.218 3.085l.394-1.621c1.122-.985 2.885-.985 2.885-.985a8.735 8.735 0 0 0 1.732-2.487 1.028 1.028 0 0 1 1.462-.679 9.662 9.662 0 0 1 1.665-1.158c.818-.425 1.767.424 1.767.424l.101 3.132s.081.115.212.289zM334.904 132.245c.424.718.542 3.37.542 3.37l-1.182.942-2.245-6.485-.102-3.369-.042-.191.034.038a3.303 3.303 0 0 1 1.597-2.279l1.529 2.041.513 2.449s-.14.344-1.021 1.023c-.881.679.377 2.461.377 2.461zM350.092 120.523a9.146 9.146 0 0 1-1.335 4.775c-.135-.242-.216-.522-.351-.768-.191-.344-.632-.633-.958-.425a.996.996 0 0 0-.301.425c-.267.564-.741 1.129-1.364 1.116a1.354 1.354 0 0 1-1.161-.993 4.104 4.104 0 0 1-.067-1.622c.093-1.103.11-2.376-.708-3.119a4.618 4.618 0 0 0-1.771-.793c-.623-.204-1.271-.527-1.525-1.129-.169-.425-.127-.875-.28-1.274a2.223 2.223 0 0 0-1.648-1.213 4.316 4.316 0 0 1-2.885.988 10.792 10.792 0 0 1-2.838-.449 9.17 9.17 0 0 1 10.32-4.423 9.19 9.19 0 0 1 6.872 8.892v.012zM334.34 176.027a94.49 94.49 0 0 1-6.287.212c-.966 0-1.987 0-3.046-.047a65.223 65.223 0 0 1-9.985-1.031c-4.402-.849-8.473-2.313-11.015-4.792.423-.823.809-1.506.953-1.748 0-.238 0-.514-.025-.811 4.469 2.122 18.403 8.017 29.083 4.669 0 .352.051.585.051.585l.242.204c-.123.441-.047 1.893.029 2.759z"
        fill="#000"
      />
      <path
        d="M122.89 361.367a5.843 5.843 0 0 1-1.3-4.443l18.7-153.282 1.55-12.732a5.872 5.872 0 0 1 5.779-5.16l54.774-.365a5.869 5.869 0 0 0 5.821-6.031l-.021-.582a5.878 5.878 0 0 1 1.644-4.281 5.858 5.858 0 0 1 4.215-1.792h57.558a5.864 5.864 0 0 1 5.808 6.646 5.879 5.879 0 0 0 1.35 4.588 5.852 5.852 0 0 0 4.31 2.058l55.279 1.414c1.7.042 3.299.823 4.379 2.139a5.876 5.876 0 0 1 1.247 4.719L316.348 355.96l-.521 3.056a5.76 5.76 0 0 1-.848 2.19l-192.089.161z"
        fill="#585F66"
      />
      <path
        d="m225.942 230.757 63.292-91.773 28.01 19.386-63.292 91.773-28.01-19.386z"
        fill="url(#xnrx95vl6b)"
        opacity=".5"
      />
      <path
        d="m289.707 140.225 26.63 18.431-62.445 90.544-26.63-18.431 62.445-90.544z"
        fill="#F9FAFB"
      />
      <path
        d="m291.626 144.515 18.763 13.066-13.043 18.796-18.763-13.066 13.043-18.796z"
        fill="currentColor"
      />
      <path
        opacity=".5"
        d="m276.927 167.166 18.826 13.029-13.006 18.859-18.826-13.029 13.006-18.859z"
        fill="currentColor"
      />
      <path
        opacity=".3"
        d="m261.221 189.935 18.825 13.029-13.006 18.859-18.826-13.03 13.007-18.858z"
        fill="currentColor"
      />
      <path
        d="m220.101 240.188 31.117-106.668 32.678 9.567-31.117 106.668-32.678-9.567z"
        fill="url(#x2b9ww5ilc)"
        opacity=".5"
      />
      <path
        d="m252.083 134.554 31.068 9.095-30.699 105.235-31.068-9.095 30.699-105.235z"
        fill="#F9FAFB"
      />
      <path
        d="m256.162 137.592 21.963 6.43-6.419 22.001-21.963-6.429 6.419-22.002z"
        fill="currentColor"
      />
      <path
        opacity=".5"
        d="m248.412 164.154 21.963 6.43-6.418 22.001-21.963-6.429 6.418-22.002z"
        fill="currentColor"
      />
      <path
        opacity=".3"
        d="m240.664 190.712 21.963 6.43-6.418 22.001-21.963-6.429 6.418-22.002z"
        fill="currentColor"
      />
      <path
        d="m220.159 246.146 8.897-110.771 33.935 2.735-8.897 110.771-33.935-2.735z"
        fill="url(#4lf5fg9mgd)"
        opacity=".5"
      />
      <path
        d="m230.076 136.214 32.263 2.6-8.777 109.283-32.263-2.601 8.777-109.282z"
        fill="#F9FAFB"
      />
      <path
        d="m234.668 138.363 22.808 1.838-1.836 22.848-22.807-1.838 1.835-22.848z"
        fill="currentColor"
      />
      <path
        opacity=".5"
        d="m232.45 165.941 22.808 1.838-1.836 22.849-22.807-1.839 1.835-22.848z"
        fill="currentColor"
      />
      <path
        opacity=".3"
        d="m230.236 193.528 22.807 1.838-1.835 22.848-22.807-1.838 1.835-22.848z"
        fill="currentColor"
      />
      <path
        d="m214.411 139.913 34.009-1.553 5.052 111.014-34.01 1.553-5.051-111.014z"
        fill="url(#t51im97nke)"
        opacity=".5"
      />
      <path
        d="m215.561 140.608 32.334-1.477 4.984 109.522-32.334 1.477-4.984-109.522z"
        fill="#fff"
      />
      <path
        d="m220.381 142.156 22.858-1.044 1.042 22.899-22.858 1.043-1.042-22.898z"
        fill="currentColor"
      />
      <path
        opacity=".5"
        d="m222.535 168.924 22.882-1.147 1.144 22.922-22.882 1.147-1.144-22.922z"
        fill="currentColor"
      />
      <path
        opacity=".3"
        d="m222.896 197.445 22.858-1.044 1.042 22.898-22.858 1.044-1.042-22.898z"
        fill="currentColor"
      />
      <path
        d="m229.291 285.089-28.758 11.145-42.03 16.276c-1.589-2.971-3.928-6.986-6.821-11.777-9.956-16.526-26.428-42.232-41.095-64.823-16.522-25.464-30.744-46.952-30.744-46.952l10.295-2.971 84.095-24.458 55.058 123.56z"
        fill="#E6ECF8"
      />
      <path
        opacity=".1"
        d="m229.291 285.089-28.757 11.145a215.801 215.801 0 0 1-48.865 4.499c-9.956-16.526-26.427-42.232-41.094-64.823l-20.433-49.94 84.091-24.441 55.058 123.56z"
        fill="#000"
      />
      <path
        d="M250.686 278.155s-44.675 26.474-111.375 20.486L86.138 168.774l25.483-4.389 88.095-15.155 49.991 126.399.979 2.526z"
        fill="currentColor"
      />
      <path
        opacity=".1"
        d="M249.69 275.646c-10.519.518-22.691.467-34.934-.997-13.252-1.562-26.581-4.779-38.006-10.678-9.554-4.927-17.722-10.287-24.844-16.717-18.526-16.692-29.99-40.569-40.285-82.852l88.095-15.155 49.974 126.399z"
        fill="#000"
      />
      <path
        d="M282.464 268.385s-32.931 6.459-66.45 2.483c-13.252-1.562-26.58-4.779-38.006-10.678-9.554-4.928-17.717-10.288-24.843-16.718-22.928-20.664-35.036-52.333-47.522-116.286 0 0 54.745 13.237 108.88-15.758-.017.022 18.229 114.092 67.941 156.957z"
        fill="#F9FAFB"
      />
      <path
        opacity=".1"
        d="M216.014 270.868c-13.252-1.562-26.58-4.779-38.006-10.678-9.554-4.928-17.717-10.288-24.843-16.717 19.522-1.588 22.326-12.278 22.326-12.278 14.472 23.006 40.523 39.673 40.523 39.673z"
        fill="#000"
      />
      <path
        opacity=".3"
        d="M133.96 150.664s44.518-2.521 56.948-12.133l1.885 6.069s-29.414 12.999-58.833 13.156v-7.092zM133.96 180.627s43.103-2.364 75.669-18.122l1.102 2.521s-25.843 15.113-76.771 19.068v-3.467zM137.43 192.302s43.103-2.364 75.665-18.122l1.101 2.521s-25.843 15.109-76.766 19.069v-3.468zM140.896 203.995s43.102-2.364 75.669-18.122l1.097 2.521s-25.843 15.113-76.766 19.068v-3.467zM144.365 215.687s43.103-2.364 75.665-18.122l1.102 2.521s-25.843 15.113-76.767 19.068v-3.467zM147.831 227.383s43.102-2.363 75.669-18.122l1.097 2.521s-25.843 15.109-76.766 19.069v-3.468z"
        fill="currentColor"
      />
      <ellipse
        opacity=".1"
        cx="349.638"
        cy="380.359"
        rx="43.213"
        ry="3.921"
        fill="#8B31F1"
      />
      <path
        d="M400.994 239.36a4.006 4.006 0 0 0-.043-.424c0-.149-.046-.297-.072-.425a16.507 16.507 0 0 0-.182-.849c-.034-.131-.068-.267-.106-.394a10.765 10.765 0 0 0-2.118-4.104c-.055-.068-.114-.132-.169-.195a9.143 9.143 0 0 0-.674-.675c-.11-.098-.212-.187-.313-.272a11.93 11.93 0 0 0-.56-.424c-.165-.119-.241-.162-.343-.221a1.88 1.88 0 0 0-.796-.259l-1.759-.174-2.402-.238-8.587-3.34-.339.119a19.308 19.308 0 0 1-.635-2.122c.26-.113.491-.282.677-.496.203-.158.363-.364.466-.599.216-.501-.199-1.566-.114-2.177.136-.98.644-1.927 1.059-2.814.881-1.905 1.525-3.972 1.419-6.064-.106-2.093-1.059-4.215-2.821-5.382-.911-.607-1.983-.929-2.932-1.481-.737-.424-1.385-.993-2.088-1.477a11.99 11.99 0 0 0-11.829-.849c-1.783.879-3.304 2.194-4.986 3.251s-3.665 1.868-5.635 1.554c-.027.08-.047.162-.059.246l-.165-.022c-.339.926.491 1.842 1.271 2.475 1.453 1.201 3.101 2.398 4.994 2.44.733 0 1.509-.14 2.174.161a2 2 0 0 1 .423.255 9.468 9.468 0 0 0 2.966 9.426l-4.385-1.579s-.182.094-.466.272l-6.084-4.058s-12.197-4.43-15.586 2.471c-3.389 6.9 14.688 3.34 14.688 3.34l3.868 2.122c-.13.801.02 1.622.424 2.325l10.545 6.528c-2.119.657-5.631 1.697-6.253 1.697-.903 0-3.39.891-4.97 4.452-1.58 3.561-7.232 20.932-12.201 23.826-4.97 2.894-18.073 22.268-18.073 22.268l.059.153a12.14 12.14 0 0 0-.686.204 13.882 13.882 0 0 0-6.808 5.144 2.184 2.184 0 0 0 1.525 3.442c5.173.657 7.998-1.732 9.358-3.536.089-.114.17-.229.246-.343.403.173.854.194 1.271.059l6.325-5.123s-4.948 4.881-2.046 9.337l-.22.31a70.9 70.9 0 0 0-10.592 23.096s-2.711 2.003-2.936 10.02c-.224 8.017-2.94 20.932-2.94 20.932s-1.805 15.367-.678 20.04c0 0 .132.187.373.471a9.747 9.747 0 0 1-.279.323c-.988 1.069-2.767 2.546-4.839 2.122-3.16-.671-3.16 4.897 1.356 5.343 2.911.284 8.63 1.587 12.337 2.478a2.595 2.595 0 0 0 2.329-.55 2.605 2.605 0 0 0 .891-2.225c-.221-1.995-.623-4.41-1.356-6.129-.047-.106-.093-.212-.14-.31.131-.127.267-.254.398-.39 0 0 0-9.799 1.585-12.469 0 0 4.291-20.265 4.063-25.388-.174-4.006 11.138-19.611 16.06-26.202l-.042-.251a245.312 245.312 0 0 1 2.059-2.716l3.809 24.276s1.809 5.343 4.067 8.238c0 0 9.714 18.482 10.845 24.271.848 4.393 2.618 6.986 3.423 7.987l-.292.281c-1.029.946-2.542 1.892-4.262 1.532-3.16-.671-3.16 4.897 1.356 5.343 2.91.288 8.63 1.591 12.332 2.483a2.604 2.604 0 0 0 3.224-2.78c-.258-2.317-.762-5.199-1.737-6.901a4.697 4.697 0 0 0-.258-.424c.344-.138.652-.355.898-.633 0 0-5.876-14.03-5.876-17.825 0 0-2.483-14.472-10.841-19.815 0 0 .788-18.105 3.169-28.18.059-.246.118-.493.178-.73a67.292 67.292 0 0 0 6.592-1.375l.224-6.68 1.131 5.343 12.651-7.792s-.11-1.405-.322-3.557c-.11-1.078-.242-2.342-.399-3.713a297.878 297.878 0 0 0-.423-3.446c-.043-.297-.081-.599-.123-.896a140.04 140.04 0 0 0-.542-3.603l-.229-1.324a98.772 98.772 0 0 0-.322-1.698c-.055-.276-.114-.551-.17-.819-.055-.267-.118-.534-.177-.793l-.178-.76c-.034-.123-.064-.246-.094-.365-.063-.242-.127-.48-.19-.709a12.768 12.768 0 0 1-.458-2.92v-1.175c0-.391.06-.781.115-1.172.025-.191.059-.386.097-.577.144-.776.358-1.537.64-2.275.14-.369.301-.734.474-1.095.424-.848.848-1.752 1.297-2.716.228-.479.457-.972.686-1.472.229-.501.462-1.01.695-1.528 2.198-4.911 4.368-10.381 4.948-13.976.059-.378.106-.734.127-1.069.025-.305.029-.611.013-.917z"
        fill="url(#2f7kod6xpf)"
      />
      <path
        d="m363.259 226.038-7.452-5.046s-11.833-4.393-15.12 2.415c-3.288 6.807 14.243 3.293 14.243 3.293l7.452 4.168.877-4.83z"
        fill="#AE6E79"
      />
      <path
        d="m282.41 267.906 38.543-60.062 93.338 60.108-38.544 60.063-93.337-60.109z"
        fill="#F9FAFB"
      />
      <path
        d="m296.24 263.717 10.815-17.051 4.005 2.549-10.815 17.051-4.005-2.549zM309.042 267.171l23.75-37.448 3.673 2.338-23.751 37.447-3.672-2.337zM316.887 272.16l23.75-37.448 3.673 2.337-23.751 37.448-3.672-2.337zM324.729 277.156l23.751-37.447 3.673 2.337-23.751 37.448-3.673-2.338z"
        fill="#ACB7B2"
      />
      <path
        d="m332.845 284.396 23.916-37.268 3.655 2.353L336.5 286.75l-3.655-2.354z"
        fill="#059282"
      />
      <path
        d="m340.417 287.14 23.75-37.448 3.673 2.337-23.751 37.448-3.672-2.337zM348.262 292.128l23.751-37.447 3.672 2.337-23.751 37.448-3.672-2.338z"
        fill="#fff"
      />
      <path
        d="m381.197 270.856 6.15-9.697 9.68 6.161-6.15 9.697-9.68-6.161z"
        fill="#ACB7B2"
      />
      <path
        d="M385.302 379.943c-3.597-.878-9.143-2.16-11.964-2.444-4.385-.425-4.385-5.942-1.314-5.272 1.661.361 3.135-.577 4.131-1.506a9.69 9.69 0 0 0 .847-.93 2.548 2.548 0 0 1 1.42-.87c1.643-.356 5.083-.899 7.164.234.486.303.879.734 1.135 1.248.945 1.697 1.436 4.519 1.695 6.79a2.548 2.548 0 0 1-.847 2.182 2.536 2.536 0 0 1-2.267.568zM329.858 382.137c-3.592-.878-9.138-2.16-11.96-2.444-4.384-.425-4.384-5.942-1.317-5.267 2.008.424 3.736-1.023 4.69-2.075.118-.128.224-.251.313-.365a2.538 2.538 0 0 1 1.415-.849c1.644-.361 5.084-.904 7.168.233.619.331 1.11 1.061 1.504 2.008.708 1.697 1.098 4.074 1.314 6.039a2.548 2.548 0 0 1-.864 2.167 2.533 2.533 0 0 1-2.263.553z"
        fill="#BEBED0"
      />
      <path
        opacity=".1"
        d="M331.671 373.361c-5.232 5.402-9.718-.102-10.4-1.01.118-.128.224-.251.313-.365a2.538 2.538 0 0 1 1.415-.849c1.644-.361 5.084-.904 7.168.233.619.314 1.132 1.044 1.504 1.991zM386.742 370.403c-2.266 1.549-9.896 1.167-9.896 1.167a7.115 7.115 0 0 1-.691-.849 9.69 9.69 0 0 0 .847-.93 2.548 2.548 0 0 1 1.42-.87c1.643-.356 5.083-.899 7.164.234.494.299.894.732 1.156 1.248z"
        fill="#000"
      />
      <path
        d="M387.145 369.376c-1.538 1.977-10.299 1.536-10.299 1.536s-2.631-2.636-3.729-8.34c-1.097-5.704-10.519-23.927-10.519-23.927-2.19-2.857-3.944-8.123-3.944-8.123l-3.724-23.928s-17.967 23.707-17.747 28.757c.22 5.051-3.948 25.04-3.948 25.04-1.534 2.635-1.534 12.308-1.534 12.308-5.694 5.941-10.515-1.1-10.515-1.1-1.097-4.609.657-19.756.657-19.756s2.63-12.732 2.846-20.634c.217-7.902 2.852-9.876 2.852-9.876a70.44 70.44 0 0 1 10.29-22.773c1.322-1.897 2.199-2.912 2.199-2.912l35.498 4.172a22.406 22.406 0 0 0-1.525 4.711c-2.309 9.931-3.076 27.777-3.076 27.777 8.109 5.267 10.519 19.523 10.519 19.523 0 3.713 5.699 17.545 5.699 17.545z"
        fill="#3859C9"
      />
      <g opacity=".05" fill="#000">
        <path d="m352.977 309.518-.458-2.924s-17.967 23.707-17.747 28.757c.221 5.051-3.944 25.04-3.944 25.04-1.538 2.635-1.538 12.308-1.538 12.308a7.483 7.483 0 0 1-3.427 2.202c1.724.454 3.813.119 6.058-2.202 0 0 0-9.66 1.534-12.308 0 0 4.164-19.977 3.944-25.04-.169-3.951 10.799-19.34 15.578-25.833z" />
        <path d="M381.662 351.814s-2.41-14.269-10.515-19.523c0 0 .767-17.846 3.072-27.777a22.417 22.417 0 0 1 1.529-4.711l-35.498-4.163s-.084.093-.237.28l33.104 3.892a22.464 22.464 0 0 0-1.525 4.711c-2.309 9.931-3.076 27.777-3.076 27.777 8.109 5.267 10.52 19.522 10.52 19.522 0 3.731 5.698 17.562 5.698 17.562-.907 1.163-4.321 1.49-6.978 1.562 2.119.055 8.334.076 9.605-1.562 0-.008-5.699-13.84-5.699-17.57z" />
      </g>
      <path
        d="M333.455 292.546a8.023 8.023 0 0 1-1.038 1.817c-1.318 1.778-4.059 4.129-9.075 3.484a2.163 2.163 0 0 1-1.483-3.395 13.509 13.509 0 0 1 6.605-5.093c.908-.3 1.848-.491 2.801-.569l2.19 3.756z"
        fill="#AE6E79"
      />
      <path
        d="m379.735 231.152-17.573-6.438s-5.042 2.635-3.068 6.366l17.112 10.758 3.529-10.686z"
        fill="#42383C"
      />
      <path
        opacity=".985"
        d="m379.803 231.224-17.578-6.438s-5.041 2.631-3.067 6.366l17.09 10.755 3.555-10.683z"
        fill="#0E6E63"
      />
      <path
        d="M380.349 220.542s-.22 10.317 4.385 13.831c4.605 3.514-13.37 5.488-13.37 5.488s2.851-10.538 0-16.026c-2.852-5.487 8.985-3.293 8.985-3.293z"
        fill="#AE6E79"
      />
      <path
        opacity=".1"
        d="M375.528 299.791a22.406 22.406 0 0 0-1.525 4.711c-21.183 3.242-35.947-5.59-35.947-5.59a5.85 5.85 0 0 1-.225-.382c1.322-1.897 2.199-2.911 2.199-2.911l35.498 4.172zM333.455 292.546a7.995 7.995 0 0 1-1.038 1.816c-2.029-.339-3.652-4.244-3.953-4.982.908-.3 1.848-.491 2.801-.569l2.19 3.735z"
        fill="#000"
      />
      <path
        d="m382.103 229.764-7.888 2.852-3.288 4.393s-6.778 2.194-7.668 2.194c-.89 0-3.288.878-4.821 4.388-1.534 3.51-7.012 20.643-11.833 23.491-4.821 2.848-17.531 21.95-17.531 21.95s2.191 5.942 4.822 5.05l6.134-5.05s-4.821 4.83-1.974 9.222c0 0 17.971 10.755 42.734 4.168l.216-6.583 1.097 5.267 12.286-7.681s-1.097-14.171-3.076-21.382a13.06 13.06 0 0 1 .848-9.086c3.181-6.642 8.091-17.736 7.494-21.781-.707-4.766-3.389-6.837-4.423-7.461a1.823 1.823 0 0 0-.771-.258l-4.012-.399-8.346-3.294z"
        fill="#069A89"
      />
      <path
        opacity=".05"
        d="M368.627 251.825s-4.385 20.413-9.206 23.707c-4.822 3.293-17.747 13.831-18.188 15.588"
        fill="#000"
      />
      <path
        d="M366.652 251.167s-4.38 20.414-9.201 23.707c-4.822 3.293-17.751 13.831-18.188 15.584"
        fill="#0E6E63"
      />
      <path
        opacity=".1"
        d="M370.817 236.898s15.12-5.05 19.488-3.734l-19.488 3.734z"
        fill="#000"
      />
      <g opacity=".05" fill="#000">
        <path d="M392.139 262.961c3.182-6.642 8.092-17.736 7.495-21.78-.708-4.766-3.389-6.837-4.423-7.461a1.825 1.825 0 0 0-.771-.259l-1.695-.17c.18.041.352.111.509.208 1.025.628 3.715 2.695 4.418 7.465.598 4.041-4.312 15.139-7.49 21.78a13.057 13.057 0 0 0-.847 9.083c1.983 7.215 3.08 21.381 3.08 21.381l-10.566 6.616.267 1.274 12.286-7.682s-1.097-14.171-3.076-21.381a13.06 13.06 0 0 1 .813-9.074zM388.458 232.837l1.898.191-8.253-3.264-.741.268 7.096 2.805z" />
      </g>
      <path
        opacity=".05"
        d="M366.652 272.459s6.779-3.73 8.986-2.852c2.207.879 10.299-.221 10.299-.221M379.595 223.288c-.25-2.203.767-1.867.767-1.867s-11.833-2.195-8.986 3.293a12.582 12.582 0 0 1 1.203 4.825h.115c3.287.005 5.207-3.679 6.901-6.251z"
        fill="#000"
      />
      <ellipse cx="372.681" cy="219.226" rx="9.422" ry="9.439" fill="#AE6E79" />
      <path
        opacity=".1"
        d="M382.984 222.019c.848-1.88 1.479-3.917 1.377-5.98-.101-2.062-1.025-4.155-2.737-5.309-.881-.594-1.923-.913-2.842-1.456-.716-.424-1.347-.98-2.03-1.456a11.466 11.466 0 0 0-11.472-.848c-1.729.848-3.203 2.168-4.834 3.208-1.631 1.04-3.554 1.838-5.465 1.532-.331.913.479 1.812 1.22 2.441 1.411 1.184 3.008 2.363 4.847 2.402.711 0 1.461-.136 2.118.161.435.241.804.585 1.076 1.002a19.74 19.74 0 0 1 2.237 3.798 3.146 3.146 0 0 0 1 1.477c.847.543 1.944.089 2.965.051 1.559-.064 2.966.921 4.118 1.973 1.152 1.053 2.254 2.258 3.711 2.814 1.089.424 3.267.399 3.813-.904.208-.492-.195-1.545-.11-2.147.204-.963.544-1.892 1.008-2.759z"
        fill="#000"
      />
      <path
        d="M383.179 221.794c.847-1.88 1.483-3.917 1.377-5.976-.106-2.058-1.021-4.159-2.733-5.309-.885-.598-1.927-.917-2.842-1.46-.716-.424-1.347-.976-2.03-1.455a11.464 11.464 0 0 0-11.472-.849c-1.729.849-3.203 2.164-4.834 3.204-1.631 1.04-3.554 1.842-5.465 1.532-.331.917.474 1.816 1.22 2.44 1.411 1.184 3.008 2.364 4.847 2.407.711 0 1.461-.14 2.118.161.437.238.807.583 1.076 1.002a19.51 19.51 0 0 1 2.233 3.794 3.153 3.153 0 0 0 1.004 1.477c.847.543 1.944.089 2.965.051 1.559-.06 2.966.925 4.114 1.977 1.148 1.053 2.254 2.254 3.715 2.81 1.089.424 3.267.399 3.813-.904.212-.492-.19-1.545-.106-2.148.202-.961.539-1.888 1-2.754z"
        fill="#4E323E"
      />
      <path
        opacity=".1"
        d="M314.971 361.18a4.36 4.36 0 0 1-2.805.993l-189.276-.806a5.843 5.843 0 0 1-1.3-4.443l18.7-153.282 11.727-.127a4.433 4.433 0 0 1 4.321 3.276l2.19 8.098a4.432 4.432 0 0 0 4.381 3.276l46.801-1.124a4.436 4.436 0 0 0 4.325-4.439v-5.365a4.435 4.435 0 0 1 4.381-4.439l64.853-.7a4.432 4.432 0 0 1 4.393 3.603l28.681 150.238.187.968a4.417 4.417 0 0 1-1.559 4.273z"
        fill="#000"
      />
      <path
        d="m281.151 204.224-64.853.7a4.435 4.435 0 0 0-4.385 4.435v5.369a4.437 4.437 0 0 1-4.322 4.435l-46.796 1.124a4.428 4.428 0 0 1-4.385-3.276l-2.199-8.093a4.428 4.428 0 0 0-4.325-3.277l-62.51.675a4.426 4.426 0 0 0-3.354 1.59 4.441 4.441 0 0 0-.968 3.588l25.148 148.269a4.433 4.433 0 0 0 4.351 3.696l197.482.849a4.426 4.426 0 0 0 3.425-1.604 4.445 4.445 0 0 0 .943-3.667l-28.859-151.21a4.43 4.43 0 0 0-4.393-3.603z"
        fill="#ACB7B2"
      />
      <defs>
        <linearGradient
          id="z8lir6rusa"
          x1="353.405"
          y1="114.289"
          x2="353.405"
          y2="113.249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity=".25" />
          <stop offset=".54" stopColor="gray" stopOpacity=".12" />
          <stop offset="1" stopColor="gray" stopOpacity=".1" />
        </linearGradient>
        <linearGradient
          id="xnrx95vl6b"
          x1="253.952"
          y1="250.143"
          x2="317.324"
          y2="158.383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity=".25" />
          <stop offset=".54" stopColor="gray" stopOpacity=".12" />
          <stop offset="1" stopColor="gray" stopOpacity=".1" />
        </linearGradient>
        <linearGradient
          id="x2b9ww5ilc"
          x1="252.781"
          y1="249.751"
          x2="283.943"
          y2="143.075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity=".25" />
          <stop offset=".54" stopColor="gray" stopOpacity=".12" />
          <stop offset="1" stopColor="gray" stopOpacity=".1" />
        </linearGradient>
        <linearGradient
          id="4lf5fg9mgd"
          x1="254.09"
          y1="248.881"
          x2="263"
          y2="138.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity=".25" />
          <stop offset=".54" stopColor="gray" stopOpacity=".12" />
          <stop offset="1" stopColor="gray" stopOpacity=".1" />
        </linearGradient>
        <linearGradient
          id="t51im97nke"
          x1="253.483"
          y1="249.377"
          x2="248.424"
          y2="138.359"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity=".25" />
          <stop offset=".54" stopColor="gray" stopOpacity=".12" />
          <stop offset="1" stopColor="gray" stopOpacity=".1" />
        </linearGradient>
        <linearGradient
          id="2f7kod6xpf"
          x1="400.981"
          y1="382.018"
          x2="400.981"
          y2="202.874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity=".25" />
          <stop offset=".54" stopColor="gray" stopOpacity=".12" />
          <stop offset="1" stopColor="gray" stopOpacity=".1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EmptyIllustration;
